import { PdTab } from "./pd-tab/PdTab.js";
//#region src/pd-tab/pd-tab.ts
var tag = "pd-tab";
if (!customElements.get(tag)) customElements.define(tag, PdTab);
//#endregion
export { PdTab };
